import { z } from 'zod';

export enum VersionState {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    LOCKED = 'LOCKED',
}

export const VersionStateSchema = z.enum(VersionState);
